document.documentElement.classList.remove('no-js');

class DrawerToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', () => {
      this.toggleDrawer();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.toggleDrawer();
    });
  }

  toggleDrawer() {
      const controls = this.getAttribute('aria-controls');
      const target = controls ? document.getElementById(controls) : null;
      if (!target) return;
      const open = target.hasAttribute('open');
      target.toggleAttribute('open', !open);
      this.setAttribute('aria-expanded', String(!open));
      document.documentElement.classList.toggle('drawer-open', !open);
  }
}

customElements.define('drawer-toggle', DrawerToggle);

const closeDrawers = () => {
  document.querySelectorAll('.drawer[open]').forEach((drawer) => drawer.removeAttribute('open'));
  document.querySelectorAll('drawer-toggle[aria-expanded="true"]').forEach((toggle) => {
    toggle.setAttribute('aria-expanded', 'false');
  });
  document.documentElement.classList.remove('drawer-open');
};

document.addEventListener('click', (event) => {
  const close = event.target.closest('[data-drawer-close]');
  if (!close) return;
  closeDrawers();
});

document.addEventListener('click', (event) => {
  if (!document.documentElement.classList.contains('drawer-open')) return;
  if (event.target.closest('.drawer') || event.target.closest('drawer-toggle')) return;
  closeDrawers();
});

document.addEventListener('change', (event) => {
  const autoSubmit = event.target.closest('[data-auto-submit]');
  if (autoSubmit && autoSubmit.form) autoSubmit.form.submit();
});

document.addEventListener('toggle', (event) => {
  const group = event.target.closest('.mobile-nav__group');
  if (!group || !group.open) return;

  const nav = group.closest('.mobile-nav');
  if (!nav) return;

  nav.querySelectorAll('.mobile-nav__group[open]').forEach((item) => {
    if (item !== group) item.removeAttribute('open');
  });
}, true);

const formatCartMoney = (cents) => {
  const amount = Number(cents || 0) / 100;
  const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'RSD';

  try {
    return new Intl.NumberFormat('sr-RS', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(amount);
  } catch (error) {
    return `${amount.toLocaleString('sr-RS')} ${currency}`;
  }
};

const escapeHtml = (value) => {
  const div = document.createElement('div');
  div.textContent = value || '';
  return div.innerHTML;
};

const translatePaymentButtons = () => {
  document.querySelectorAll('.shopify-payment-button__button').forEach((button) => {
    if (button.textContent.trim() === 'Buy it now') {
      button.textContent = 'Kupi odmah';
      button.setAttribute('aria-label', 'Kupi odmah');
    }
  });
};

translatePaymentButtons();

const paymentButtonObserver = new MutationObserver(() => translatePaymentButtons());
paymentButtonObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});

const openCartDrawer = () => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.setAttribute('open', '');
  document.documentElement.classList.add('drawer-open');
  document.querySelectorAll('drawer-toggle[aria-controls="CartDrawer"]').forEach((toggle) => {
    toggle.setAttribute('aria-expanded', 'true');
  });
};

const showCartToast = () => {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  toast.classList.add('is-visible');
  window.clearTimeout(showCartToast.timer);
  showCartToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
};

const renderCartDrawer = (cart) => {
  const body = document.querySelector('[data-cart-drawer-body]');
  if (!body || !cart) return;

  document.querySelectorAll('.cart-link__count').forEach((count) => {
    count.textContent = cart.item_count;
  });

  if (!cart.items.length) {
    body.innerHTML = `
      <div class="cart-drawer__empty">
        <p>Korpa je prazna.</p>
        <a class="button button--primary" href="/collections/all">Nastavi kupovinu</a>
      </div>
    `;
    return;
  }

  const items = cart.items.map((item) => {
    const productTitle = escapeHtml(item.product_title);
    const variantTitle = escapeHtml(item.variant_title);
    const image = item.image
      ? `<a class="cart-drawer__image" href="${item.url}"><img src="${item.image}" alt="${productTitle}" loading="lazy"></a>`
      : `<a class="cart-drawer__image" href="${item.url}"></a>`;
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span>${variantTitle}</span>`
      : '';

    return `
      <div class="cart-drawer__item" data-cart-item-key="${item.key}">
        ${image}
        <div class="cart-drawer__details">
          <a href="${item.url}">${productTitle}</a>
          ${variant}
          <strong>${formatCartMoney(item.final_line_price)}</strong>
          <div class="ajax-quantity" data-cart-quantity>
            <button type="button" data-cart-decrement aria-label="Smanji kolicinu">-</button>
            <input type="number" min="0" value="${item.quantity}" aria-label="Kolicina za ${productTitle}">
            <button type="button" data-cart-increment aria-label="Povecaj kolicinu">+</button>
          </div>
        </div>
      </div>
    `;
  }).join('');

  body.innerHTML = `
    <div class="cart-drawer__items">${items}</div>
    <div class="cart-drawer__footer">
      <div class="cart-drawer__subtotal">
        <span>Ukupno</span>
        <strong>${formatCartMoney(cart.total_price)}</strong>
      </div>
      <a class="button button--secondary button--full" href="/cart">Pogledaj korpu</a>
      <form action="/cart" method="post">
        <button class="button button--primary button--full" type="submit" name="checkout">Placanje</button>
      </form>
    </div>
  `;
};

const renderCartPage = (cart) => {
  if (!cart) return;
  document.querySelectorAll('.cart-page [data-cart-item-key]').forEach((element) => {
    const item = cart.items.find((cartItem) => cartItem.key === element.dataset.cartItemKey);
    if (!item) {
      element.remove();
      return;
    }

    const input = element.querySelector('[data-cart-quantity] input');
    const linePrice = element.querySelector('[data-cart-line-price]');
    if (input) input.value = item.quantity;
    if (linePrice) linePrice.textContent = formatCartMoney(item.final_line_price);
  });

  document.querySelectorAll('[data-cart-subtotal]').forEach((subtotal) => {
    subtotal.textContent = formatCartMoney(cart.total_price);
  });

  if (cart.item_count === 0 && document.querySelector('.cart-page')) {
    window.location.reload();
  }
};

const fetchCart = () => fetch('/cart.js', {
  headers: { 'Accept': 'application/json' }
}).then((response) => response.ok ? response.json() : null);

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-product-card-form], [data-product-form]');
  if (!form) return;
  event.preventDefault();

  const button = form.querySelector('.product-card__quick-add, [data-add-to-cart]');
  if (button && button.disabled) return;
  if (button) button.classList.add('is-loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    },
    body: new FormData(form)
  })
    .then((response) => {
      if (!response.ok) throw new Error('cart add failed');
      form.classList.add('is-added');
      return fetchCart();
    })
    .then((cart) => {
      if (!cart) return;
      renderCartDrawer(cart);
      renderCartPage(cart);
      openCartDrawer();
      showCartToast();
    })
    .catch(() => {
      form.submit();
    })
    .finally(() => {
      if (button) button.classList.remove('is-loading');
      window.setTimeout(() => form.classList.remove('is-added'), 1800);
    });
});

document.addEventListener('click', (event) => {
  const quantity = event.target.closest('[data-cart-quantity]');
  if (!quantity) return;

  const item = event.target.closest('[data-cart-item-key]');
  const input = quantity.querySelector('input');
  if (!item || !input) return;

  const current = Number(input.value || 0);
  let next = current;
  if (event.target.closest('[data-cart-increment]')) next = current + 1;
  if (event.target.closest('[data-cart-decrement]')) next = Math.max(0, current - 1);
  if (next === current) return;

  input.value = next;
  quantity.classList.add('is-loading');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: item.dataset.cartItemKey, quantity: next })
  })
    .then((response) => {
      if (!response.ok) throw new Error('cart change failed');
      return response.json();
    })
    .then((cart) => {
      renderCartDrawer(cart);
      renderCartPage(cart);
    })
    .catch(() => {
      window.location.href = '/cart';
    });
});

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-cart-quantity] input');
  if (!input) return;

  const item = input.closest('[data-cart-item-key]');
  if (!item) return;

  const next = Math.max(0, Number(input.value || 0));
  input.value = next;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: item.dataset.cartItemKey, quantity: next })
  })
    .then((response) => {
      if (!response.ok) throw new Error('cart change failed');
      return response.json();
    })
    .then((cart) => {
      renderCartDrawer(cart);
      renderCartPage(cart);
    })
    .catch(() => {
      window.location.href = '/cart';
    });
});

const siteHeader = document.querySelector('.site-header');
if (siteHeader) {
  const updateHeaderState = () => {
    siteHeader.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}

const mobileBottomNav = document.querySelector('.mobile-bottom-nav');
if (mobileBottomNav) {
  let lastScrollY = window.scrollY;
  let mobileBottomNavTicking = false;

  const updateMobileBottomNav = () => {
    const currentScrollY = Math.max(window.scrollY, 0);
    const scrollDelta = currentScrollY - lastScrollY;

    if (currentScrollY < 16) {
      mobileBottomNav.classList.remove('is-compact');
    } else if (scrollDelta > 6) {
      mobileBottomNav.classList.add('is-compact');
    } else if (scrollDelta < -6) {
      mobileBottomNav.classList.remove('is-compact');
    }

    lastScrollY = currentScrollY;
    mobileBottomNavTicking = false;
  };

  window.addEventListener('scroll', () => {
    if (mobileBottomNavTicking) return;
    window.requestAnimationFrame(updateMobileBottomNav);
    mobileBottomNavTicking = true;
  }, { passive: true });
}

const heroSliderTrack = document.querySelector('.hero-slider__track');
if (heroSliderTrack) {
  const slides = Array.from(heroSliderTrack.querySelectorAll('.hero-slide'));
  const dots = Array.from(document.querySelectorAll('.hero-slider__dots span'));
  let activeIndex = 0;
  let paused = false;
  let ticking = false;

  const setActiveDot = (index) => {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  };

  const goToSlide = (index) => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    heroSliderTrack.scrollTo({
      left: slides[activeIndex].offsetLeft,
      behavior: 'smooth'
    });
    setActiveDot(activeIndex);
  };

  heroSliderTrack.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      const nextIndex = Math.round(heroSliderTrack.scrollLeft / heroSliderTrack.clientWidth);
      activeIndex = Math.max(0, Math.min(nextIndex, slides.length - 1));
      setActiveDot(activeIndex);
      ticking = false;
    });
  }, { passive: true });

  heroSliderTrack.addEventListener('pointerdown', () => {
    paused = true;
    heroSliderTrack.classList.add('is-dragging');
  });

  heroSliderTrack.addEventListener('pointerup', () => {
    paused = false;
    heroSliderTrack.classList.remove('is-dragging');
  });

  heroSliderTrack.addEventListener('pointercancel', () => {
    paused = false;
    heroSliderTrack.classList.remove('is-dragging');
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index));
  });

  if (slides.length > 1) {
    window.setInterval(() => {
      if (!paused && !document.hidden) goToSlide(activeIndex + 1);
    }, 5500);
  }
}

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(() => {});
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class VariantPicker extends HTMLElement {
  connectedCallback() {
    const variantsScript = this.querySelector('[data-variants]');
    if (!variantsScript) return;

    this.variants = JSON.parse(variantsScript.textContent);
    this.form = this.closest('form');
    this.productPage = this.closest('.product-page');
    this.updateOptionAvailability();
    this.onVariantChange();
    this.addEventListener('change', () => this.onVariantChange());
  }

  getSelectedOptions() {
    return Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  updateOptionAvailability() {
    const selectedOptions = this.getSelectedOptions();

    this.querySelectorAll('fieldset').forEach((fieldset, optionIndex) => {
      fieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        const optionValue = input.value;
        const hasAvailableVariant = this.variants.some((variant) => {
          if (!variant.available || variant.options[optionIndex] !== optionValue) return false;

          return variant.options.every((value, index) => {
            return index === optionIndex || !selectedOptions[index] || value === selectedOptions[index];
          });
        });

        const label = input.closest('.variant-choice');
        input.disabled = !hasAvailableVariant;
        input.setAttribute('aria-disabled', String(!hasAvailableVariant));
        if (label) label.classList.toggle('is-unavailable', !hasAvailableVariant);
      });
    });
  }

  onVariantChange() {
    this.updateOptionAvailability();
    const selectedOptions = this.getSelectedOptions();

    const variant = this.variants.find((item) => {
      return item.options.every((option, index) => option === selectedOptions[index]);
    });

    const idInputs = this.productPage
      ? this.productPage.querySelectorAll('form input[name="id"]')
      : this.form ? this.form.querySelectorAll('input[name="id"]') : [];
    if (variant) {
      idInputs.forEach((input) => {
        input.value = variant.id;
      });
    }

    const available = Boolean(variant && variant.available);
    const forms = this.productPage ? this.productPage.querySelectorAll('[data-product-form]') : [this.form];
    forms.forEach((form) => {
      if (!form) return;
      form.classList.toggle('product-form--unavailable', !available);
      form.querySelectorAll('[data-add-to-cart]').forEach((submit) => {
        submit.disabled = !available;
        submit.textContent = available ? 'Dodaj u korpu' : 'Rasprodato';
      });
    });
  }
}

customElements.define('variant-picker', VariantPicker);
